'use client';
import React from 'react';
import { useT } from '@/components/I18nProvider';
import { LOCALES, LOCALE_SHORT, type Locale } from '@/lib/i18n';

/**
 * Kalbos perjungiklis — LT / RU / EN. Pasirinkimas įsimenamas (cookie), tad
 * kitą kartą atsidarius lieka ta pati kalba. Rodomas prisijungimo lange ir
 * operatoriaus/meistro ekranuose, kad ne lietuviškai kalbantys galėtų perjungti.
 */
export default function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { locale, setLocale } = useT();
  return (
    <div className={`inline-flex overflow-hidden rounded-lg border border-black/10 ${className}`} role="group" aria-label="Language">
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          onClick={() => setLocale(l)}
          aria-pressed={locale === l}
          className={`px-2.5 py-1 text-xs font-semibold transition ${
            locale === l ? 'bg-slate-900 text-white' : 'bg-white/70 text-slate-600 hover:bg-white'
          }`}
        >
          {LOCALE_SHORT[l]}
        </button>
      ))}
    </div>
  );
}
